import supabase from '../supabaseClient';
import { GrupoMesDescargas } from './GrupoMesDescargas';

export const DescargasOperadores = ({ llegadas, setLlegadas, cargarLlegadas }) => {
  const eliminar = async (id) => {
    if (window.confirm("¿Eliminar este registro?")) {
      await supabase.from('registro_llegadas').delete().eq('id', id);
      setLlegadas(prev => prev.filter(x => x.id !== id));
    }
  };
  const grupos = {};
  llegadas.forEach(l => {
    const fecha = new Date(l.hora_llegada);
    const mes = fecha.toLocaleDateString("es-ES", { month: "long", year: "numeric" });
    const dia = fecha.toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" });
    if (!grupos[mes]) grupos[mes] = {};
    if (!grupos[mes][dia]) grupos[mes][dia] = [];
    grupos[mes][dia].push(l);
  });
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="font-bold text-gray-800">🚚 Descargas Operadores</h2>
        <button onClick={cargarLlegadas} className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded-lg border border-blue-200">🔄 Actualizar</button>
      </div>
      {llegadas.length === 0 && (
        <div className="bg-white rounded-xl shadow p-8 text-center text-gray-400">
          <p className="text-4xl mb-2">🚚</p>
          <p className="text-sm">No hay registros de llegada aún. Pulsa Actualizar.</p>
        </div>
      )}
      {Object.keys(grupos).sort((a, b) => b.localeCompare(a)).map(mes => (
        <GrupoMesDescargas key={mes} mes={mes} diasObj={grupos[mes]} onEliminar={eliminar} />
      ))}
    </div>
  );
};
